import React from 'react';
import Img from 'gatsby-image';
import { Parallax, Background } from 'react-parallax';
import { Link, graphql } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';

import Facebook from '../assets/img/icons/social/facebook.inline.svg';

import { replaceAnchorLinksByLanguage } from '../utils/i18n';
import get from 'lodash.get';
const path = require('path').posix;

class BlogPostTemplate extends React.Component {
    render() {
        const markdownRemark = this.props.data.markdownRemark;
        let { previous, next, slug } = this.props.pageContext;
        const lang = markdownRemark.fields.langKey;
        let html = markdownRemark.html;
        const { isEditing, setIsEditing } = this.props;

        return (
            <Layout location={this.props.location} title={markdownRemark.frontmatter.title}>
                <SEO lang={lang} title={markdownRemark.frontmatter.title} description={markdownRemark.excerpt} author={markdownRemark.frontmatter.author} />

                <Parallax strength={800}>
                    <Background>
                        <Img fixed={markdownRemark.frontmatter.featuredImage.childImageSharp.fixed} />
                    </Background>
                    <section className="py-12 py-md-15 d-none d-lg-block" />
                    <section className="py-10 d-none d-lg-block" />
                </Parallax>
                <div className="d-lg-none img-cover">
                    <div className="w-100">
                        <Img fluid={markdownRemark.frontmatter.featuredImage.childImageSharp.fluid} className="w-100" />
                    </div>
                </div>

                <section className="pt-8 pt-md-11">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-10 col-lg-9 col-xl-8">
                                <h1 className="display-4 text-center">{markdownRemark.frontmatter.title}</h1>
                                <div className="row align-items-center py-5 border-top border-bottom">
                                    <div className="col-auto">
                                        <div className="avatar avatar-lg">
                                            <Img fixed={markdownRemark.frontmatter.authorImage.childImageSharp.fixed} className="avatar-img rounded-circle" />
                                        </div>
                                    </div>
                                    <div className="col ml-n5">
                                        <h6 className="text-uppercase mb-0">{markdownRemark.frontmatter.author}</h6>
                                        <time className="font-size-sm text-muted">{markdownRemark.frontmatter.date}</time>
                                    </div>
                                    <div className="col-auto">
                                        <span className="h6 text-uppercase text-muted d-none d-md-inline mr-4">Share:</span>
                                        <ul className="d-inline list-unstyled list-inline list-social">
                                            <li className="list-inline-item list-social-item mr-3">
                                                <a
                                                    href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fboard-off.com${markdownRemark.frontmatter.path}`}
                                                    target="_blank"
                                                    rel="noreferrer noopener"
                                                    className="text-decoration-none"
                                                >
                                                    <Facebook className="list-social-icon" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-6 py-md-8">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-10 col-lg-9 col-xl-8" dangerouslySetInnerHTML={{ __html: markdownRemark.html }} />
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}
export default BlogPostTemplate;

export const pageQuery = graphql`
    query BlogPostBySlug($slug: String!) {
        site {
            siteMetadata {
                title
                author
            }
        }
        markdownRemark(fields: { slug: { eq: $slug } }) {
            id
            html
            timeToRead
            frontmatter {
                title
                date(formatString: "MMMM DD, YYYY")
                author
                authorImage {
                    childImageSharp {
                        fixed(height: 36, width: 36, quality: 99) {
                            ...GatsbyImageSharpFixed
                        }
                    }
                }
                featuredImage {
                    childImageSharp {
                        fixed(width: 2200, quality: 95) {
                            ...GatsbyImageSharpFixed
                        }
                        fluid(quality: 95) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
            fields {
                slug
                langKey
            }
        }
    }
`;
